import { graphql } from 'gatsby';

import { SEO } from 'components';
import { Section } from 'components/GridV2';
import { Hero, HowItWorks, Rewards } from 'components/pages/referral';
import { FAQ } from 'components/rebrand/FAQ';
import { Layout } from 'components/rebrand/Layout';

import { IReferralPageProps } from 'typescriptDefs/pages/referral';

import { useGtagRemarketing } from 'helpers';
import { afTrackingByPage } from 'helpers/getAfTracking';

const Referral = ({
  data: { page },
  pageContext: { linkCanonical, locale, pageIsMultilingual, pageName, schemaMarkupJson, variant },
  ...props
}: IReferralPageProps) => {
  useGtagRemarketing('9ST-CK_GspYDEI-zyK4D');

  return (
    <Layout location={props.location} pageIsMultilingual={pageIsMultilingual} pageName={pageName} pageVariant={variant}>
      <SEO
        canonical={linkCanonical}
        title={page.metadata.title}
        description={page.metadata.description}
        keywords={page.metadata.keywords}
        imageSrc={page.metadata.image?.asset.gatsbyImageData.images.fallback?.src}
        location={props.location}
        multilingual={pageIsMultilingual}
        structuredData={schemaMarkupJson}
      />
      <Hero
        data={{
          btnText: page.onboardingBtnText,
          heroContent: page.heroContent,
          heroImg: page.heroImg,
          heroImgAltText: page.heroImgAltText,
          tracking: {
            queryParams: afTrackingByPage('REFERRAL'),
            trackEventProps: {
              category: pageName,
              label: 'Referral Hero',
              locale,
              location: variant,
            },
          },
        }}
      />
      <Rewards heading={page.rewardsHeading} rewards={page.rewards} subheading={page.rewardsSubheading} />
      <HowItWorks heading={page.instructionsHeading} items={page.phoneInstruction} />
      <Section className="py-64 md:py-96">
        <FAQ faqItems={page.faq.faqItems} heading={page.faq.heading} subheading={page.faq.subheading} />
      </Section>
    </Layout>
  );
};

export default Referral;

export const queryGraphQL = graphql`
  query ($_id: String!) {
    page: sanityPageReferralV2(_id: { eq: $_id }) {
      faq {
        ...sanityFAQ
      }
      heroContent: _rawHeroContent
      heroImg {
        asset {
          gatsbyImageData(placeholder: NONE, width: 886)
        }
      }
      heroImgAltText
      instructionsHeading
      metadata {
        ...sanityMetadata
      }
      onboardingBtnText
      phoneInstruction {
        img {
          asset {
            gatsbyImageData(placeholder: NONE, width: 506)
          }
        }
        imgAltText
        text
      }
      rewardsHeading
      rewardsSubheading
      rewards {
        img {
          img {
            asset {
              gatsbyImageData(placeholder: NONE, width: 1108)
            }
          }
          altText
        }
        mobileImg {
          asset {
            gatsbyImageData(placeholder: NONE, width: 622)
          }
        }
        content: _rawContent
      }
    }
  }
`;
